"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityFinalNegotiationSharingDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_final_negotiation_entity_1 = require("./opportunity-final-negotiation.entity");
const insurer_entity_1 = require("./insurer.entity");
let OpportunityFinalNegotiationSharingDetail = class OpportunityFinalNegotiationSharingDetail {
};
exports.OpportunityFinalNegotiationSharingDetail = OpportunityFinalNegotiationSharingDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationSharingDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'opportunity_final_negotiation_id', type: 'int' }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationSharingDetail.prototype, "opportunityFinalNegotiationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'insurer_id', type: 'int' }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationSharingDetail.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'share_percentage', type: 'numeric' }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationSharingDetail.prototype, "sharePercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'brokerage_percentage', type: 'numeric' }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationSharingDetail.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'brokerage_amount', type: 'numeric' }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationSharingDetail.prototype, "brokerageAmount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_final_negotiation_entity_1.OpportunityFinalNegotiation, (neg) => neg.sharingDetails, { onDelete: 'CASCADE' }),
    (0, typeorm_1.JoinColumn)({ name: 'opportunity_final_negotiation_id' }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiationSharingDetail.prototype, "finalNegotiation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => insurer_entity_1.Insurer),
    (0, typeorm_1.JoinColumn)({ name: 'insurer_id' }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiationSharingDetail.prototype, "insurer", void 0);
exports.OpportunityFinalNegotiationSharingDetail = OpportunityFinalNegotiationSharingDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)('opportunity_final_negotiation_sharing_detail')
], OpportunityFinalNegotiationSharingDetail);
